// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__eE4Qq","VAcctTxt":"VirtualAccount_VAcctTxt__Esukz","VFundTxt":"VirtualAccount_VFundTxt__7G+Tm","VBank":"VirtualAccount_VBank__baC-N"};